// frontend/src/themes/palettes/synthwave.js
import { sharedComponents } from "./shared";
export default {
  muiMode: "dark",
  scrollbarColor: "#7C4DFF",
  palette: {
    primary:    { main: "#FF3CAC" },
    secondary:  { main: "#00E5FF" },
    background: { default: "#180438", paper: "#23104D" },
    text:       { primary: "#F3E8FF", secondary: "#B39DDB" },
    divider:    "rgba(255,60,172,0.18)",
    action:     { hover: "rgba(255,255,255,0.05)", selected: "rgba(255,60,172,0.14)" },
  },
  components: {
    ...sharedComponents,
    MuiButton: {
      styleOverrides: {
        ...sharedComponents.MuiButton.styleOverrides,
        containedPrimary: {
          boxShadow: "0 0 12px rgba(255,60,172,0.45)",
          "&:hover": { boxShadow: "0 0 16px rgba(255,60,172,0.6)" },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6, backgroundColor: "#2C1660" },
        notchedOutline: { borderColor: "rgba(0,229,255,0.35)" },
        input: { color: "#F3E8FF", "&::placeholder": { color: "#8E7CC3", opacity: 1 } },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: { color: "#F3E8FF", "&::placeholder": { color: "#8E7CC3", opacity: 1 } },
      },
    },
    MuiFormLabel: { styleOverrides: { root: { color: "#B39DDB" } } },
  },
  custom: {
    chat: {
      sentBg: "#3A1568", sentText: "#F3E8FF",
      receivedBg: "#241048", receivedText: "#F3E8FF",
      quotedSentBg: "#4A1C82", quotedReceivedBg: "#2E1458", accent: "#00E5FF", contactAccent: "#FF3CAC",
    },
    chartPalette: ["#FF3CAC", "#00E5FF", "#FFD54F", "#7C4DFF", "#69F0AE", "#FF8A80"],
    login: { bg: "#180438" },
    headingFont: "Orbitron",
  },
};
